import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/edit.svg
 */
const IconEdit: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M19.567 0a4.423 4.423 0 00-3.166 1.301l-8.066 8.07a7.297 7.297 0 00-2.156 5.207v3.244h3.243a7.314 7.314 0 005.203-2.16L22.7 7.595A4.45 4.45 0 0019.533 0h.034zM21.07 5.95l-8.066 8.07a5 5 0 01-3.565 1.477h-.922v-.918a5.024 5.024 0 011.479-3.56l8.07-8.07a2.123 2.123 0 013.006-.002 2.127 2.127 0 01.002 3.006l-.004-.003z"
      fill="currentColor"
    />
    <path
      d="M4.264 24.02h13.95a4.26 4.26 0 004.26-4.26V13.56H20.15v6.202a1.938 1.938 0 01-1.937 1.935H4.264a1.938 1.938 0 01-1.938-1.935V5.81a1.938 1.938 0 011.938-1.938h6.199V1.548h-6.2A4.263 4.263 0 000 5.81v13.95a4.263 4.263 0 004.264 4.26z"
      fill="currentColor"
    />
  </svg>
);

export default IconEdit;
